import { filesize } from "filesize";
import { isEmail } from "./validation-utils.js";

const rules = {
  isRequired: [(v) => v !== null && v !== undefined && v !== "", "Plichtfeld"],
  isSlug: [
    (v) => /^[a-z0-9-]*$/.test(v),
    "Kein gültiger Slug (nur kleine Buchstaben, 0-9 und '-' erlaubt)",
  ],
  isEmail: [(v) => isEmail(v), "Keine gültige Email."],
  isTag: [(v) => /^\d\d\d\d$/.test(v), "Muss aus 4 Zahlen bestehen"],
  isUrl: [
    (v) => typeof v === "object" || (v !== "" && /^https?:\/\//.test(v)),
    "Link muss mit http:// oder https:// beginnen",
  ],
  isDigits: [(v) => /^\d*$/.test(v), "Nur Zahlen"],
  minLength: (num) => [
    (v) => v.length >= num,
    `Muss mindestens ${num} Zeichen lang sein`,
  ],
  maxLength: (num) => [
    (v) => v.length <= num,
    `Darf höchstens ${num} Zeichen lang sein`,
  ],
  maxNumber: (num) => [(v) => v <= num, `Darf höchstens ${num} sein`],
  equalTo: (fieldName) => [
    (v, values) => v === values[fieldName],
    `Die Eingabe stimmt nicht überein.`,
  ],
  isMax25MB: [
    (v) => !v || !v.size || v.size < 25 * 1024 * 1024,
    (v) =>
      `Die Datei ${v.name ? v.name : ""} ist ${v.size ? filesize(v.size) : "zu"} groß. Sie darf aber höchstens 25MB groß sein. Wähle eine kleinere Datei aus.`,
  ],
  isImage: [
    (v) =>
      !v ||
      (typeof v === "object" &&
        v.type &&
        (v.type.startsWith("image/png") ||
          v.type.startsWith("image/jpeg") ||
          v.type.startsWith("image/gif") ||
          v.type.startsWith("image/webp"))),
    "Du kannst nur Bilder im png-, jpeg-, gif-, oder webp-Format hochladen. Wähle eine andere Datei zum Hochladen aus.",
  ],
  isImageOrAudioOrApplicationOrTextOrVideo: [
    (v) => {
      return (
        v === null ||
        typeof v === "string" ||
        (typeof v === "object" &&
          v.type &&
          (v.type.startsWith("image/png") ||
            v.type.startsWith("image/jpeg") ||
            v.type.startsWith("image/gif") ||
            v.type.startsWith("image/webp") ||
            v.type.startsWith("audio/mpeg") ||
            v.type.startsWith("application/pdf") ||
            v.type.startsWith("video/mp4")))
      );
    },
    "Du kannst nur Bilder (png, jpeg, gif, webp), Videos (mp4), Audio-Dateien (mp3) oder PDFs hochladen. Wähle eine andere Datei zum Hochladen aus.",
  ],
};

export { rules };
